import React from 'react';
import withConfig from '../../context/withConfig';

const DefaultLauncherSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <g fill="#fff" fillRule="evenodd">
      <path d="M100.172 27.773H92.9V13.822H7.377v13.95H.104V6.448h100.068v21.326M50.138 98.313L39.6 79.35H.104V63.863h7.272v7.915h36.418l6.344 11.415 6.343-11.415H92.9v-7.915h7.272V79.35H60.676L50.138 98.313" />
    </g>
  </svg>
);

export default withConfig(DefaultLauncherSvg);



// WEBPACK FOOTER //
// ./src/components/Launcher/DefaultLauncherSvg.js